<div class="container mt-4">
    <!-- Loading State -->
    <div *ngIf="loading" class="text-center py-5">
        <output class="spinner-border text-primary">
            <span class="visually-hidden">Cargando...</span>
        </output>
        <p class="mt-2 text-muted">Cargando productos disponibles...</p>
    </div>

    <!-- Error State -->
    <div
        *ngIf="error && !loading"
        class="alert alert-danger alert-dismissible fade show"
        role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ error }}
        <button type="button" class="btn-close" (click)="error = ''"></button>
    </div>

    <!-- Main Content -->
    <div *ngIf="!loading" class="card main-card">
        <div class="bg-gradient-primary text-white">
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0">
                    <i class="bi bi-box-seam me-2"></i>
                    Relacionar productos que comercializa la empresa
                </h5>
                <span class="badge bg-light text-dark">
                    {{ productosSeleccionados.length }} seleccionados
                </span>
            </div>
        </div>

        <div class="card-body p-4">
            <div class="row g-4">
                <!-- Tipos de producto -->
                <div class="col-xl-3 col-lg-4">
                    <app-tipos-producto
                        [tipos]="categoriasProductos"
                        [tiposSeleccionados]="categoriasSeleccionadas"
                        (tipoSeleccionado)="alternarSeleccionCategoria($event)"
                        [getTipoColor]="
                            obtenerColorPorTipo.bind(this)
                        "></app-tipos-producto>
                </div>

                <!-- Productos disponibles -->
                <div class="col-xl-4 col-lg-4">
                    <app-lista-productos
                        [productos]="productosFiltrados"
                        [tipo]="'disponibles'"
                        [getTipoColor]="obtenerColorPorTipo.bind(this)"
                        [getTipoNombre]="obtenerNombreTipo.bind(this)"
                        (agregarProducto)="agregarProductoASeleccion($event)">
                        <!-- Mensajes informativos -->
                        <div
                            *ngIf="categoriasSeleccionadas.length === 0"
                            class="alert alert-info mt-3">
                            <i class="bi bi-info-circle me-2"></i>
                            Seleccione al menos un tipo de producto para ver los
                            disponibles.
                        </div>

                        <div
                            *ngIf="
                                categoriasSeleccionadas.length > 0 &&
                                productosFiltrados.length === 0
                            "
                            class="alert alert-warning mt-3">
                            <i class="bi bi-exclamation-triangle me-2"></i>
                            No hay productos disponibles para los tipos
                            seleccionados.
                        </div>
                    </app-lista-productos>
                </div>

                <!-- Productos seleccionados -->
                <div class="col-xl-4 col-lg-4">
                    <app-lista-productos
                        [productos]="productosSeleccionados"
                        [tipo]="'seleccionados'"
                        [getTipoColor]="obtenerColorPorTipo.bind(this)"
                        [getTipoNombre]="obtenerNombreTipo.bind(this)"
                        (quitarProducto)="quitarProductoDeSeleccion($event)">
                        <div
                            *ngIf="productosSeleccionados.length === 0"
                            class="alert alert-secondary mt-3">
                            <i class="bi bi-cart me-2"></i>
                            No hay productos seleccionados.
                        </div>
                    </app-lista-productos>
                </div>
            </div>

            <!-- Botón guardar -->
            <div class="action-footer mt-4">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="selection-info">
                        <span class="text-muted">
                            {{ productosSeleccionados.length }} producto(s)
                            seleccionado(s)
                        </span>
                    </div>
                    <div>
                        <button
                            class="btn btn-save text-white"
                            [disabled]="productosSeleccionados.length === 0"
                            (click)="guardarSeleccion()">
                            <i class="bi bi-check-lg me-2"></i>
                            Guardar Selección
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
